import React from "react";

import "./PageFilterBar.scss";

// Fontaine M54D — PageFilterBar: the filter row Buy Alerts ships, made shared.
// Guillaume's brief: "the search bar is the right length and the one button and
// the filter below that should be the base you can put on the pages below".
//
// Geometry, and the only geometry: a fixed-length search pill on the left, every
// filter control pinned right. The pill length is a page decision — set
// `--rc-filterbar-search-w` on the page root, normally to two of that page's
// cards plus the gap, so the field lines up with the first two grid columns.
//
// It renders no control of its own and knows no filter vocabulary — the page
// keeps every handler, value and request shape, exactly as with FiltersBar.
// FiltersBar (ft-filters, M38) stays the primitive for an ELASTIC row where the
// search field absorbs the free space; this one is for the fixed-pill pages.
//
// @param {ReactNode} search     leading slot — normally a <SearchInput size="lg">
// @param {ReactNode} children   the filter controls, in reading (and tab) order
// @param {string} label         accessible name for the row
export default function PageFilterBar({ search, children, label, className = "" }) {
  return (
    <div
      className={`rc-filterbar ${className}`.trim()}
      role="search"
      aria-label={label}
    >
      {/* The pill is sized on this wrapper, not on the field: SearchInput's own
          `.ft-search` is elastic (`flex: 1 1 240px`) and a single class, so a
          page class on the field only ties on specificity and loses on source
          order — which is what let the field absorb the whole row. */}
      {search ? <div className="rc-filterbar__search">{search}</div> : null}

      <div className="rc-filterbar__right">{children}</div>
    </div>
  );
}
